import { sanitize, isBase64 } from './index';

/**
 * Decodes, sanitizes, and parses a Base64-encoded JSON string.
 *
 * @param {string} base64EncodedJson - A Base64-encoded JSON string.
 * @returns {object|null} - The decoded and parsed JSON object, or null if invalid.
 */
export default function decodeAndSanitizeJSON(base64EncodedJson) {
  if (!base64EncodedJson) {
    throw new Error('No data provided');
  }

  if (!isBase64(base64EncodedJson)) {
    throw new Error('Invalid Base64 string');
  }

  try {
    const decodedInfo = atob(base64EncodedJson);
    const sanitizedInfo = sanitize(decodedInfo);
    return JSON.parse(sanitizedInfo);
  } catch (error) {
    throw new Error(`Failed to decode and parse data: ${error.message}`);
  }
}
